import { LayerBottom } from "components"

const DetailTip = ({ title, show, closeLayer, content, children  }) => {
	return (
		<LayerBottom title={title} show={show} closeLayer={closeLayer}>
			<div className="layer-text">
				{content}
				{children}
			</div>
		</LayerBottom>
	)
}

export default DetailTip